import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { HelmetProvider } from "react-helmet-async";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import Upgrade from "./pages/Upgrade";
import Intro from "./pages/Intro";
import Login from "./pages/Login";
import Home from "./pages/Home";
import History from "./pages/History";
import Register from "./pages/Register";
import FinishSignUp from "./pages/FinishSignUp";
import Feedback from "./pages/Feedback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Profile from "./pages/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import PrivacyFooter from "./components/PrivacyFooter";
import Result from "./pages/Result";
import { Outlet } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";

function AppLayout() {
  return (
    <div style={styles.shell}>
      <Navbar />
      <div style={{ padding: 20 }}></div>
      <Outlet />
    </div>
  );
}
/* ---------------- APP ---------------- */

export default function App() {
  return (
    <HelmetProvider>
    <ErrorBoundary>
      <BrowserRouter>
      <SubscriptionProvider>
        <Routes>

          {/* Public */}
          <Route path="/" element={<Intro />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/finishSignUp" element={<FinishSignUp />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/upgrade" element={<Upgrade />} />

          {/* App Layout */}
          <Route element={<AppLayout />}>

            {/* Main flow */}
            <Route path="/home" element={<Home />} />
            <Route path="/home/result" element={<Result />} />

            {/* Protected */}
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

          </Route>

        </Routes>
        <PrivacyFooter />
        <Analytics />
      </SubscriptionProvider>
      </BrowserRouter>
    </ErrorBoundary>
    </HelmetProvider>
  );
}

/* ---------------- STYLES ---------------- */

const styles = {
  shell: {
    position: "relative",
    minHeight: "100vh"
  },
  container: { padding: 20, maxWidth: 420, margin: "auto", fontFamily: "sans-serif" },
  logo: { width: 120, display: "block", margin: "auto" },
  card: { background: "#f5f5f5", padding: 15, borderRadius: 12, marginTop: 10 },
  input: { width: "100%", padding: 10, borderRadius: 10, marginBottom: 10 },
  button: { padding: 10, borderRadius: 10, marginTop: 10 },
  grid: { display: "flex", flexWrap: "wrap", gap: 8 },
  chip: { padding: "8px 12px", borderRadius: 20, border: "none", background: "#e6f2e6" },
  dropdown: { background: "#fff", border: "1px solid #ddd", borderRadius: 10 },
  dropdownItem: { padding: 10, cursor: "pointer", borderBottom: "1px solid #eee" },
  reassurance: { marginTop: 10, fontStyle: "italic" }
};
